import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AppCard } from './AppCard';
const apps = [{
  icon: '🤖',
  iconUrl: 'https://cdn.magicpatterns.com/uploads/49Liq2am7bQX8SzqUQSQks/download.svg',
  name: 'Elkarte | Sociedades Gastronómicas',
  description: 'Elkarte is a React-based SaaS digitizing gastronomic societies with automated bookings, inventory management, and Stripe billing, delivered through a high-performance, mobile-first Progressive Web App.',
  status: 'Live' as const,
  accentColor: 'forest' as const,
  link: 'https://elkarte.eus',
  tags: ['Lovable', 'React', 'Supabase', 'Tailwind', 'Stripe Billing']
}, {
  icon: '🔄',
  name: 'Little Loop',
  description: 'A communication platform for kindergartens and parents. Simplifying daily updates, announcements, and parent-teacher interaction.',
  status: 'In Progress' as const,
  accentColor: 'amber' as const,
  tags: ['React', 'Supabase', 'Tailwind']
}, {
  icon: '🏀',
  name: 'Dinasty Fuel',
  description: 'A personal Fantasy NBA management website for tracking rosters, trades, and dynasty league strategy.',
  status: 'In Progress' as const,
  accentColor: 'flame' as const,
  tags: ['React', 'Supabase', 'Tailwind']
}, {
  icon: '🃏',
  name: 'Card Hunt',
  description: 'A personal trading card price tracking app. Monitor market values, track your collection, and spot trends.',
  status: 'Coming Soon' as const,
  accentColor: 'forest' as const,
  tags: ['React', 'Supabase', 'Tailwind']
}, {
  icon: '🎲',
  name: 'Game Night Score',
  description: 'An app to manage scoring across different board games. Keep track of points, rounds, and winners in one place.',
  status: 'Coming Soon' as const,
  accentColor: 'amber' as const,
  tags: ['React', 'Tailwind']
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function AppShowcase() {
  return <section className="py-16 px-6" data-id="element-28">
      <div className="max-w-6xl mx-auto" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-bold text-cream mb-3" data-id="element-31">
            What I'm Building
          </h2>
          <p className="text-parchment max-w-xl mx-auto" data-id="element-32">
            Apps crafted with AI, shipped with vibes. Here's what's cooking.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-33">
          {apps.map(app => <motion.div key={app.name} variants={itemVariants} data-id="element-34">
              <AppCard {...app} data-id="element-35" />
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}